module.exports = __webpack_public_path__ + "static/media/share.4454ac76.svg";